export function getdata() {
	let obj = {
		formdatajbxx: {
			cains: "",
			qij1: "",
			qij2: "",
		},
		formlistjbxx: [{
				prop: "cains",
				label: "财务年度	",
				type: "select",
				selectval: [],
				isnotnull: true,
			},
			{
				prop: "qij1",
				label: "财务期间始",
				type: "select",
				selectval: [],
				isnotnull: true,

			}, {
				prop: "qij2",
				label: "财务期间止",
				type: "select",
				selectval: [],
				isnotnull: true,

			},

		],
	}
	return obj
}
